import { Type, type Static } from '@sinclair/typebox';
import { MinimalUser } from '../../shared/user/user.schema';
import { ListResponseSchema } from '../../shared/utils/list-response.schema';
import { relationRequestSchema } from './relation-request.schema';

export const GetRelationRequestsListResponseSchema = ListResponseSchema(relationRequestSchema);

export const CreateRelationRequestResponseSchema = relationRequestSchema;

export const CancelRelationRequestResponseSchema = Type.Object({ object: Type.Literal('RelationRequestCanceled') });

export const AcceptRelationRequestResponseSchema = Type.Object({ object: Type.Literal('RelationRequestConfirmed') });

export type GetRelationRequestsListResponse = Static<typeof GetRelationRequestsListResponseSchema>;
export type CreateRelationRequestResponse<UserSpecifics = unknown> = Omit<
  Static<typeof CreateRelationRequestResponseSchema>,
  'user'
> & {
  user?: MinimalUser<UserSpecifics>;
};
export type CancelRelationRequestResponse = Static<typeof CancelRelationRequestResponseSchema>;
export type AcceptRelationRequestResponse = Static<typeof AcceptRelationRequestResponseSchema>;
